import { useCallback, useState } from 'react';
import {
  getAtsEmbedContext,
  isJobDescriptionPrefilled,
  markJobDescriptionPrefilled
} from '../utils/atsEmbedContext';
import { useEmbeddedJobDescription } from './useEmbeddedJobDescription';

export const useEmbeddedSearchPrefill = (enabled: boolean) => {
  const [jobId] = useState(() => getAtsEmbedContext()?.jobId ?? null);
  const [isHandled, setIsHandled] = useState(
    () => !!jobId && isJobDescriptionPrefilled(jobId)
  );
  const jobDescription = useEmbeddedJobDescription({
    enabled: enabled && !isHandled
  });

  const onPrefillHandled = useCallback(() => {
    if (jobId) markJobDescriptionPrefilled(jobId);
    setIsHandled(true);
  }, [jobId]);

  return {
    prefilledSearchQuery:
      jobDescription.status === 'ready' ? jobDescription.text : null,
    onPrefillHandled
  };
};
